import { css } from '@emotion/react';
import { SecondaryProps, p2r } from '../../../styles/fonts';
import { breakpoints } from '../../../styles';

const styles = ({ width, maxWidth, fontSize, lineHeight }) => css`
  .text {
    width: ${width};
    max-width: ${maxWidth};
    margin: 0;
    font-size: ${p2r(36)};
    font-weight: normal;
    line-height: ${p2r(42)};
  }

  .text__last-word {
    display: block;
    padding-left: 60px;
    font-size: ${p2r(fontSize)};
    font-weight: bold;
    line-height: ${p2r(lineHeight)};
    text-align: right;
    letter-spacing: ${p2r(-3.6)};
  }

  .text__start-part {
    letter-spacing: ${p2r(-1.8)};
  }

  .text__all-text--mobile {
    display: none;
  }

  @media (max-width: ${breakpoints.smallTablet}px) {
    .text__start-part,
    .text__last-word {
      display: none;
    }

    .text__all-text--mobile {
      display: block;
      font-size: ${p2r(28)};
      font-weight: bold;
      line-height: ${p2r(32)};
      letter-spacing: ${p2r(-1.4)};
    }

    .text {
      max-width: 100%;
    }

    @media (max-width: ${breakpoints.mobile}px) {
      max-width: ${maxWidth};
    }
  }

  ${SecondaryProps}
`;

export default styles;
